import type {ParserT} from '@freckle/parser'
import {Parser, string, number, record, nullable, array} from '@freckle/parser'
import type {IdentityProviderT} from '@freckle/educator-entities/ts/roster/identity-provider'
import {parser as identityProviderParser} from '@freckle/educator-entities/ts/roster/identity-provider'

export type StudentSimplifiedT = {
  id: number
  firstName: string
  lastName: string
}

export type TeacherSimplifiedAttrT = {
  id: number
  firstName: string
  lastName: string
}

export type CourseTableRowT = {
  id: number
  name: string
  teacher: TeacherSimplifiedAttrT
  students: Array<StudentSimplifiedT>
  grades: Array<number>
  sisId: string | undefined | null
  identityProvider: IdentityProviderT | undefined | null
}

function parse(response: unknown): CourseTableRowT {
  const studentSimplifiedAttrs = record({
    id: number(),
    firstName: string(),
    lastName: string(),
  }) as ParserT<StudentSimplifiedT>

  const attrs = record({
    id: number(),
    name: string(),
    teacher: record({
      id: number(),
      firstName: string(),
      lastName: string(),
    }),
    students: array(studentSimplifiedAttrs),
    grades: array(number()),
    sisId: nullable(string()),
    identityProvider: nullable(identityProviderParser),
  }) as ParserT<CourseTableRowT>
  return Parser.run<CourseTableRowT>(response, attrs)
}

export function parseCourseTableRows(response: Array<unknown>): Array<CourseTableRowT> {
  return response.map(parse)
}
